import { gql } from "@apollo/client"

export default gql`
    query searchPrompts(
        $searchInput: String!
        $pageSize: Int!
        $currentPage: Int!
        $sort: PromptSortFields
    ) {
        searchPrompts(
            searchInput: $searchInput
            pageSize: $pageSize
            currentPage: $currentPage
            sort: $sort
        ) {
            totalPages
            prompts {
                id
                fileName
                name
                audioLocation
                audioFormat {
                    name
                    type
                }
                languages {
                    name
                    code
                }
                user {
                    email
                }
                createdAt
                modifiedBy {
                    email
                }
                updatedAt
            }
        }
    }
`
